function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione03Img02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 931 331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.1,142.59c-1.05,7.49-1.6,15.13-1.6,22.91h0c0,90.57,73.43,164,164,164h600c90.57,0,164-73.43,164-164h0c0-90.57-73.43-164-164-164H165.5C105.32,1.5,52.72,33.92,24.19,82.24",
    style: {
      fill: "none",
      stroke: "#004996",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione03Img02);
export default __webpack_public_path__ + "static/media/sezione-03-img-02.f36486edd36c1f6006dd22efedc069e0.svg";
export { ForwardRef as ReactComponent };